import Navbar from '../components/navbar';
import Footer from '../components/footer';

import AtAGlance from '../components/indvtext/atAGlance';
import CharactersCast from '../components/indvtext/charactersCast';
import BiasReception from '../components/indvtext/biasReception';
import Blurbs from '../components/indvtext/blurbs';

import LMIC from '../data/LMIC.json'

import '../App.scss';

import { useParams } from 'react-router';
import { useState, useEffect } from "react";

// import from string https://stackoverflow.com/questions/57121467/import-a-module-from-string-variable
async function importTextData(textName) {
	const textData = await import("../data/" + textName + "/" + textName);
	return textData;
}

async function importTextCCData(textName) {
	const textCCData = await import("../data/" + textName + "/" + textName + "_CC");
	return textCCData;
}

// need to send the 5 aggregated scores 
var ccChartData = [];
var brChartData = [];

const IndvText = () => {

	const { title } = useParams();
  	const [textData, setTextData] = useState(null); // the default cant be null i think
  	const [textCCData, setTextCCData] = useState(null); // the default cant be null i think

	if (textData) {
		var docTitle = textData[0].propertyNameOriginal;
		if (textData[0].mediaType === "serial") {
			docTitle += " (Season " + textData[0].mediaId + ")";
		}
	}

	useEffect(() => {
		if (title) {
		importTextData(title)
			.then((data) => setTextData(data))
			.catch((error) => console.error("Error loading text data:", error));

		importTextCCData(title)
			.then((data) => setTextCCData(data))
			.catch((error) => console.error("Error loading CC data:", error));
		}
	}, [title]);

	useEffect(() => {
		document.title = docTitle;
	  }, [docTitle]);


	  
	var biasTags = getBiasTags(textData);
	
	if (textData && textCCData) {
		
		
		
	return (
		<div className="App">
			<header>
				<Navbar></Navbar>
				{/* <h1>{title}</h1>
				<h2>{textData[0].propertyNameOriginal}</h2> */}
			</header>
			
			<body>
				<AtAGlance
					title={title}
					brScore={calculateBRScore(textData)}
					ccScore ={calculateCCScore(textCCData)}
					totalScore={calculateScore(textData, textCCData)}
					reviewer1={textData[0]}
					reviewer2={textData[1]}
					biasTags={biasTags}/>
				<CharactersCast
					ccData={textCCData}
					chartData={ccChartData}/>
				<BiasReception
					chartData={brChartData}
					biasTags={biasTags}
					reviewer1={textData[0]}
					reviewer2={textData[1]}
					/>
				<Blurbs
					reviewer1={textData[0]}
					reviewer2={textData[1]}/>

				
				<Footer></Footer>
			</body>
		</div>
		);
	} else {
		return (
			<div className="App">
				<header>
					<Navbar></Navbar>
				</header>
			  
				<body>
					<div className='white blankpage'>
					</div>
					
					<Footer></Footer>
				</body>
			</div>
		)
	}


    
}

// returns an array of BR scores: [ethnicity, nationality, gender, sexualtiy, age]
function calculateBRScoreRev(reviewer) {
	if (reviewer) {
		var brE = reviewer.ethnicity ? reviewer.ethnicity : 0;
		var brN = reviewer.nationality ? reviewer.nationality : 0;
		var brG = reviewer.gender ? reviewer.gender : 0;
		var brS = reviewer.sexuality ? reviewer.sexuality: 0;
		var brA = reviewer.age ? reviewer.age : 0;
		return [brE*2, brN*2, brG*2, brS*2, brA*2];
	}
	return [];
}

// returns the average BR score
function calculateBRScore(textData) {	
	if (!textData) {
		console.error('Text data not found.', 0);
		return 0;
	}

	// CALCULATE BR SCORE 
	var brScoreT1 = calculateBRScoreRev(textData[0]);
	// console.log("tagger 1 br score: " + brScoreT1)
	
	if (textData[1]) {
		var brScoreT2 = calculateBRScoreRev(textData[1]);
		// console.log("tagger 2 br score: " + brScoreT2)
		
		for (let i = 0; i < 5; i++) {
			brChartData[i] = Math.round((brScoreT1[i] + brScoreT2[i]) / 2);
		}
		// console.log("br score avg: " + brChartData)
		return brChartData.reduce((sum, v) => sum + v, 0)
	} 
	
	brChartData = brScoreT1;
	return brChartData.reduce((sum, v) => sum + v, 0)
}

// returns an array of CC scores: [ethnicity, nationality, gender, sexualtiy, age]
function calculateCCScoreRev(chars, genres) {
	if (chars !== new Set()) {
		var ccE = 0; 
		var ccN = 0;
		var ccG = 0; 
		var ccS = 0; 
		var ccA = 0;
		for (const c of chars) {

			// ETH CHECK: if (char NOT just white) OR (if (char = ethX, amg, unk) AND (cast NOT white)
			var eth = c.characterEthnicitySupertags; 
			if (eth.includes("asian pacific") || eth.includes("black") || eth.includes("indigenous") || eth.includes("latinx") || eth.includes("swana")) {
				ccE += 1; 
			} else if (eth.includes("ethnicity x") || eth.includes("ambiguous") || eth.includes("unknown")) {
				if (!c.actorEthnicitySupertags.includes("white")) {
					ccE += 1;
				}
			}

			// NAT CHECK: if LMIC 
			var nat = c.characterNationalitygeo;
			nat = nat.split('\n');
			for (var i = 0; i < nat.length; i++) {
				if (LMIC.countries.includes(nat[i])) {
					ccN += 1; 
					break;
				}
			}

			// GEN CHECK: if (char NOT cis man or man X)
			var gen = c.characterGenderSupertags;
			if (gen.includes("woman") || gen.includes("intersex") || gen.includes("nonbinary") || gen.includes("trans man")) {
				ccG += 1;
			} else if (gen.includes("unknown")) {
				if (!c.actorGenderSupertags.includes("cis man")) {
					ccG += 1;
				} 
			}

			// SEX CHECK: if (char NOT straight, pres straight, unk, ambg) OR (has queer subtext)
			var sex = c.characterSexualitySupertags;
			if (!sex.includes("straight") && !sex.includes("presumed straight") && !sex.includes("ambiguous") && !sex.includes("unknown")) {
				ccS += 1;
			} else if (c.characterSexualitySecondaryTags.includes("queer subtext")) {
				ccS += 1;
			}

			// AGE CHECK: if (char is over 50) OR (unknown and charZ is human and actor is over 50)
			var age = c.characterAge;

			if (age.includes("50-59") || age.includes("60-69") || age.includes("70-79") || age.includes("80-89") || age.includes("90-99")) {
				ccA += 1;
			} else if (age.includes("100+")) {
				if (genres && !genres.includes("fantasy") && !genres.includes("scifi"))
					ccA += 1
			} else if (age.includes("*") && c.characterz.includes("human")) {
				if (c.actorAge.includes("50-59") || c.actorAge.includes("60-69") || c.actorAge.includes("70-79") || c.actorAge.includes("80-89") || c.actorAge.includes("90-99") || c.actorAge.includes("100+")) {
					ccA += 1;
				}
			
			}


		}
		var ccScore = [ccE, ccN, ccG, ccS, ccA];
		// console.log(ccScore + " num chars: " + chars.size);
		ccScore.forEach((v, index, arr) => {
			arr[index] = Math.round((v/chars.size) * 10);
			// console.log(arr[index]);
		})
		// console.log("norm: " + ccScore);
		return ccScore;
	}
	return [];
}

// returns the average CC score
function calculateCCScore(textCCData, genres) {
	if (!textCCData) {
		console.error('Character and cast data not found.', 0);
		return 0;
	}

	var t1Chars = new Set();
	var t2Chars = new Set();
	var t1 = "";
	var t2 = "";

	for (let i = 0; i < textCCData.length; i++) {
		var c = textCCData[i];
		if (t1 === "") {
			t1 = c.tagger;
			t1Chars.add(c);
		} else if (t1 === c.tagger) {
			t1Chars.add(c);
		} else if (t2 === "") {
			t2 = c.tagger;
			t2Chars.add(c);
		} else if (t2 === c.tagger) {
			t2Chars.add(c);
		}
	}

	var ccScoreT1 = calculateCCScoreRev(t1Chars, genres);

	if (t2Chars.size > 0) {
		var ccScoreT2 = calculateCCScoreRev(t2Chars, genres);
		for (let i = 0; i < 5; i++) {
			ccChartData[i] = Math.round((ccScoreT1[i] + ccScoreT2[i]) / 2);
		}
		return ccChartData.reduce((sum, v) => sum + v, 0)
	}

	ccChartData = ccScoreT1;	
	return ccChartData.reduce((sum, v) => sum + v, 0);

}

function calculateScore(textData, textCCData) {
	if (textData) {
		const newbrScore = calculateBRScore(textData);

		var genres = (textData[0].genres);
		if (textData[1]) {
			genres = genres.concat(textData[1].genres);
		}
		const newccScore = calculateCCScore(textCCData, genres);
	
		return newbrScore + newccScore
	}
	return 0;
}

function getBiasTags(textData) {
	if (!textData) {
		console.error('Text data not found.', 0); 
		return 0;
	}

	var possibleTags = [
		"A", "A*",
		"B", "B*",
		"C", "C*",
		"D", "D*",
		"E", "E*",
		"F", "F*",
		"Q", "Q*",
		"S", "S*",
		"T", "T*",
		"V", "V*",
		"W", "W*",
		"Y", "Y*"
	]
	var biasTags = textData[0].biasTags.split(", ");
	for (let i = 0; i < biasTags.length; i++) {
		if (!possibleTags.includes(biasTags[i]))
			biasTags.splice(i, 1);
	}	

	if (textData[1]) {
		var biasTags2 = textData[1].biasTags.split(", ");

		for (let i = 0; i < biasTags2.length; i++) {
			var tag = biasTags2[i]; 
			// console.log(biasTags2);

			// asterisk takes precedence
			if (!biasTags.includes(tag) && possibleTags.includes(tag)) {

				var tStar = tag.includes("*");
				
				if (tStar && biasTags.includes(tag[0])) {
					// if tag is B* and list has B, update to B*
					biasTags[biasTags.indexOf(tag[0])] = tag;
				} else if (!tStar && !biasTags.includes(tag + "*")) {
					// if tag is B and list does not have B*, add tag
					biasTags.push(tag)
				} else if (tStar && !biasTags.includes(tag[0])) {
					// if tag is B* and list does not have B, add tag
					biasTags.push(tag);
				}
				
				// if tag is B* and list has B*, do nothing
				// if tag is B and list has B, do nothing
				// if tag is B and list has B*, do nothing
			}
		}
	}

	if (biasTags.length === 0) {
		biasTags.push("None");
	}

	return biasTags;
}

export default IndvText;